import { z } from 'zod';

import { LocationId } from './Location';

export const TopicId = z.string().brand('TopicId');
export const Topic = z.object({
  id: TopicId,
  locationId: LocationId,
  title: z.string(),
  text: z.string(),
  eyeCatchURL: z.string().url(),
  bannerURL: z.string().url().optional(),
  draft: z.boolean(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  publishedAt: z.string().datetime({ offset: true }),
});
export type TopicType = z.infer<typeof Topic>;
